import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ShieldCheck } from "lucide-react";
import { SITE } from "@/lib/site";

const NAV = [
  { label: "Leistung", href: "#leistung" },
  { label: "Social Media", href: "#social-media-dsa" },
  { label: "Ablauf", href: "#ablauf" },
  { label: "Preise", href: "#preise" },
  { label: "FAQ", href: "#faq" },
  { label: "in7sekunden", href: "#in7" },
  { label: "Business", href: "https://www.femmesonlinebusiness.com/", external: true },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#f5f1ea]/80 border-b border-black/[0.08]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 lg:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo">
          <span className="w-9 h-9 rounded-full flex items-center justify-center bg-gradient-to-br from-[#ffffff] via-[#2b2620] to-[#6b6c75] text-white">
            <ShieldCheck className="w-5 h-5" strokeWidth={2.2} />
          </span>
          <div className="leading-tight">
            <div className="font-heading text-[15px] sm:text-base font-semibold tracking-tight text-[#2b2620]">
              {SITE.brand}
            </div>
            <div className="text-[10px] sm:text-[11px] uppercase tracking-[0.18em] text-[#2b2620]/80">
              Reputationsmanagement
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              target={n.external ? "_blank" : undefined}
              rel={n.external ? "noopener noreferrer" : undefined}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className="text-sm text-[#4a3f36] hover:text-[#2b2620] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href="#kontakt"
            data-testid="header-cta-anfrage"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-[#2b2620] text-white text-sm font-semibold hover:bg-[#4a4038] transition-colors"
          >
            Unverbindlich anfragen
          </a>
        </div>

        <button
          onClick={() => setOpen(!open)}
          aria-label="Menü"
          data-testid="mobile-menu-toggle"
          className="lg:hidden w-10 h-10 inline-flex items-center justify-center text-[#2b2620]"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-black/[0.08] bg-[#f5f1ea]/95 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                target={n.external ? "_blank" : undefined}
                rel={n.external ? "noopener noreferrer" : undefined}
                onClick={() => setOpen(false)}
                className="text-base text-[#3a3128] hover:text-[#2b2620]"
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
              >
                {n.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex justify-center px-5 py-3 rounded-full bg-[#2b2620] text-white font-semibold"
              data-testid="mobile-cta-anfrage"
            >
              Unverbindlich anfragen
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
